import { Checkbox as MuiCheckbox, makeStyles } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { TickCheckPartial, TickCorrect } from '~svg-components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,

    '&:hover': {
      backgroundColor: 'unset',

      '& $checkboxIcon': {
        border: `1px solid ${theme.colors.brandAction}`,
      },
    },

    '&$disabled $checkboxIcon': {
      border: `1px solid ${theme.colors.greyE8}`,
      backgroundColor: theme.colors.greyF7,
    },
  },
  checked: {},
  disabled: {},
  indeterminate: {},
  colorPrimary: {},
  colorSecondary: {},

  checkboxIcon: {
    width: 20,
    height: 20,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.borderRadius.small,
    border: ({ checked }) =>
      `1px solid ${checked ? theme.colors.brandAction : theme.colors.greyCc}`,
    backgroundColor: ({ checked }) =>
      checked ? theme.colors.brandAction : theme.palette.common.white,

    '& svg': {
      width: 12,
      height: 12,
      fill: theme.palette.common.white,
    },
  },
}));

function CheckboxIcon({ checked, indeterminate }) {
  const classes = useStyles({ checked });

  return (
    <span className={classes.checkboxIcon}>
      {checked && (indeterminate ? <TickCheckPartial /> : <TickCorrect />)}
    </span>
  );
}
CheckboxIcon.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
};

const Checkbox = React.forwardRef((props, ref) => {
  const { classes } = props;
  const styles = useStyles();

  return (
    <MuiCheckbox
      disableRipple
      color="default"
      icon={<CheckboxIcon />}
      checkedIcon={<CheckboxIcon checked />}
      indeterminateIcon={<CheckboxIcon checked indeterminate />}
      {...props}
      ref={ref}
      classes={mergeClasses({
        baseClasses: {
          root: styles.root,
          checked: styles.checked,
          disabled: styles.disabled,
          indeterminate: styles.indeterminate,
          colorPrimary: styles.colorPrimary,
          colorSecondary: styles.colorSecondary,
        },
        newClasses: classes,
      })}
    />
  );
});

Checkbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  indeterminate: PropTypes.bool,
};

export default Checkbox;
